module.exports = __webpack_public_path__ + "media/student_v2/assets/images/menu-6edf6ad2a92e4e01f3aa934cdd604c91.svg";